export default __webpack_public_path__ + "static/media/support.4da7e7b5.png";